export default __webpack_public_path__ + "static/media/RochelleLovelace.b81323ef.png";